import { render, staticRenderFns } from "./CrmUserInformation.vue?vue&type=template&id=0dd548fb&scoped=true"
import script from "./CrmUserInformation.vue?vue&type=script&lang=js"
export * from "./CrmUserInformation.vue?vue&type=script&lang=js"
import style0 from "./CrmUserInformation.vue?vue&type=style&index=0&id=0dd548fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd548fb",
  null
  
)

export default component.exports